module.exports = __webpack_public_path__ + "static/media/Vuilniswagen.2c751bc0.mp3";